import React from 'react'

export default function Quote() {
  return (
    <div>Quote</div>
  )
}
